import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

export enum IAlertType {
  INFO = "info",
  WARNING = "warning",
  SUCCESS = "success",
  DANGER = "danger"
}

export interface IAlertConfig {
  clrAlertType?: IAlertType,
  message: string;
  clrAlertAppLevel?: boolean;
  clrAlertClosable?: boolean;
}


@Injectable({ providedIn: 'root' })
export class AlertService {
  shouldShowAlert: boolean = false;
  alertConfig: IAlertConfig = {
    clrAlertType: IAlertType.WARNING,
    message: "Waiting for messages....",
    clrAlertAppLevel: true,
    clrAlertClosable: true
  };

  private subject = new Subject<any | null>();
  private keepAfterRouteChange = false;
  private timeoutDuration = 5000; // Standard: 5 Sekunden
  private timeoutHandle: any;

  constructor(private router: Router) {
    // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // only keep for a single route change
          this.keepAfterRouteChange = false;
        } else {
          // clear alert message
          this.clear();
        }
      }
    });
  }

  show(config: IAlertConfig, duration: number = this.timeoutDuration): AlertService {
    this.shouldShowAlert = true;
    this.alertConfig = { ...this.alertConfig, ...config };

    // Falls eine frühere Nachricht angezeigt wird, entferne das alte Timeout
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }

    // Nachricht nach der angegebenen Zeit ausblenden
    this.timeoutHandle = setTimeout(() => {
      this.clear();
    }, duration);

    return this;
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string, keepAfterRouteChange = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next({ type: 'success', text: message });

    this.alertConfig.clrAlertType = IAlertType.SUCCESS;
    this.alertConfig.message = 'All engines running! :) ';
  }

  error(message: string, keepAfterRouteChange = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next({ type: 'error', text: message });
  }

  clear() {
    // clear by calling subject.next() without parameters
    this.success('', false);
    this.subject.next(null);
  }
}
